<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="col-12 bg-primary py-3  text-center" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="text-white" >
                <template #default>سفارشات من   </template>
                </m-h5></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"background-image: url(\"https:\/\/api.mybarco.ir\/storage\/assets\/Sprinkle (1).svg\");\nheight:100vh;"' class="container-fluid p-0 " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row pb-5 p-0 m-0" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-12 text-center" >
                <template #default>   <m-complete-profile-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-complete-profile-message-1><m-orders-1 v-bind='{...{"order_id_prop":true,"user_prop":true,"user_profile_prop":true,"user_description_prop":true,"order_paying_amount_prop":false,"order_paying_status_prop":false,"order_status_prop":false,"order_created_at_prop":false,"order_updated_at_prop":false,"order_transaction_updated_at_prop":false,"actions_prop":false,"order_items_prop":true,"user_cellphone_prop":true,"order_description_prop":true,"dashboardOrders":true},...{}}' :style='""' class="" ></m-orders-1></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mCompleteProfileMessage1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Message/CompleteProfileMessage1'; import mOrders1 from '@moeinmdn/miw-alpha-components/src/package/Order/Orders1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH5,mCompleteProfileMessage1,mOrders1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
